
// Chart type configuration
export const chartTypes = {
  line: {
    label: 'Line Chart',
    icon: (
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4-4 4 4 8-8" stroke="#3B82F6" />
      </svg>
    ),
    supportsBreakdown: true,
    supportsSummary: true
  },
  bar: {
    label: 'Bar Chart',
    icon: (
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" stroke="#10B981" fill="#10B981" fillOpacity="0.3" />
      </svg>
    ),
    supportsBreakdown: true,
    supportsSummary: true
  },
  area: {
    label: 'Area Chart',
    icon: (
      <svg className="w-4 h-4" viewBox="0 0 24 24">
        <path d="M3 18h18V6l-4 4-5-5-6 6v7z" fill="#8B5CF6" fillOpacity="0.6"/>
        <path fill="none" stroke="#8B5CF6" strokeWidth={2} d="M3 18l6-6 5 5 4-4"/>
      </svg>
    ),
    supportsBreakdown: true,
    supportsSummary: true
  },
  doughnut: {
    label: 'Pie Chart',
    icon: (
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" stroke="#F59E0B" fill="#F59E0B" fillOpacity="0.4" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.945 13A9.042 9.042 0 0113 20.945V13h7.945z" stroke="#EF4444" fill="#EF4444" fillOpacity="0.4" />
      </svg>
    ),
    supportsBreakdown: true,
    supportsSummary: false // Pie charts only make sense for breakdown view
  }
};

export const getDefaultChartType = () => 'line';
